export const AI_SEARCH_PATH = 'search';
export const INTELLIGENT_SEARCH_FEATURE_TOGGLE = 'intelligent-search-ISD-13839';
